export default __webpack_public_path__ + "static/media/schedule_24px.f1e1e0fd.svg";